import React, { useState } from 'react';

import cn from 'classnames';

import { Icon } from '@shared/ui';

import cls from './FileItemImg.module.css';

interface IFIleItemProps {
    imgUrl: string;
    fileName: string;
}

export const FileItemImg = ({ imgUrl, fileName }: IFIleItemProps) => {
    const [imgLoaded, setImgLoaded] = useState(false);
    const [imgError, setImgError] = useState(false);
    return (
        <>
            {(!imgLoaded || imgError) && (
                <Icon iconName="fileItemPlaceholder" width={40} height={40} />
            )}

            {!imgError && (
                <img
                    src={imgUrl}
                    alt={fileName}
                    className={cn(cls.filePreview, {
                        [cls.hidden]: !imgLoaded,
                    })}
                    onLoad={() => setImgLoaded(true)}
                    onError={() => setImgError(true)}
                />
            )}
        </>
    );
};
